/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 21:58:11 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-27 16:46:12
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.multiBrand.h1') }}</h1>
      <h2 class="fw600">
        {{ st('helpDocs.multiBrand.h2') }}
      </h2>
      <ul>
        <li>
          {{ st('helpDocs.multiBrand.li1a') }}
          <b class="fw600">{{ st('helpDocs.multiBrand.li1b') }}</b>{{ st('helpDocs.multiBrand.li1c') }}
        </li>
        <li>
          {{ st('helpDocs.multiBrand.li2a') }}
          <b class="fw600">{{ st('helpDocs.multiBrand.li2b') }}</b>{{ st('helpDocs.multiBrand.li2c') }}
        </li>
        <li>
          {{ st('helpDocs.multiBrand.li3a') }}<b class="fw600">{{ st('helpDocs.multiBrand.li3b') }}</b>{{ st('helpDocs.multiBrand.li3c') }}
        </li>
      </ul>
      <p>
        <b class="fw600">{{ st('helpDocs.multiBrand.pExA') }}</b>{{ st('helpDocs.multiBrand.pExB') }}<b class="fw600">{{ st('helpDocs.multiBrand.pExC') }}</b>{{ st('helpDocs.multiBrand.pExD') }}
      </p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
